import { render, staticRenderFns } from "./trainingPage.vue?vue&type=template&id=124410d0&scoped=true&"
import script from "./trainingPage.vue?vue&type=script&lang=js&"
export * from "./trainingPage.vue?vue&type=script&lang=js&"
import style0 from "./trainingPage.vue?vue&type=style&index=0&id=124410d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124410d0",
  null
  
)

export default component.exports